/** Role permission helpers (mirrors backend ROLE_MATRIX) */

export const ROLE_SECTIONS = {
  admin: [
    'dashboard', 'applications', 'members', 'unemployed', 'manualPayers',
    'cdas', 'scott', 'transactions', 'subscribers', 'users', 'system', 'memberAccounts', 'audit',
  ],
  supervisor: [
    'dashboard', 'applications', 'members', 'unemployed', 'manualPayers',
    'cdas', 'scott', 'transactions', 'subscribers', 'audit',
  ],
  // Marketing = people / membership (not payments)
  marketing: [
    'dashboard', 'applications', 'members', 'unemployed', 'subscribers',
  ],
  // Accountant = money side (needs manual payers list to record payments)
  // members = lookup only (import into CDAS / Scott / Manual Payers) — no Members menu
  accountant: [
    'dashboard', 'transactions', 'manualPayers', 'cdas', 'scott',
  ],
  accountantLookup: ['members'],
  viewer: [
    'dashboard', 'applications', 'members', 'unemployed', 'manualPayers',
    'cdas', 'scott', 'transactions', 'subscribers',
  ],
};

export const getPermissions = (role) => {
  const r = role || 'viewer';
  const sections = ROLE_SECTIONS[r] || ROLE_SECTIONS.viewer;
  const lookupSections = r === 'accountant' ? (ROLE_SECTIONS.accountantLookup || []) : [];
  const canWrite = ['admin', 'supervisor', 'marketing', 'accountant'].includes(r);
  const canDelete = ['admin', 'supervisor'].includes(r);
  const isSystemAdmin = r === 'admin';

  return {
    role: r,
    sections,
    lookupSections,
    canAccess: (section) => sections.includes(section) || lookupSections.includes(section),
    /** Menu / primary navigation — excludes lookup-only sections */
    canMenu: (section) => sections.includes(section),
    canWrite: (section) => {
      if (lookupSections.includes(section) && !sections.includes(section)) return false;
      return canWrite && sections.includes(section);
    },
    canDelete: (section) => canDelete && sections.includes(section),
    isSystemAdmin,
    /** Legacy: anyone who can mutate at least one operational section */
    canMutate: canWrite,
  };
};
